package org.hs_soft.runmynesto.data.api_datasource.product.tabs.tab_product_general

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.encodeToJsonElement
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient

import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.update_product.UpdateProductModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_product_general.UpdateProductRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

import org.hs_soft.runmynesto.domain.config.Errors


class UpdateProductRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): UpdateProductRepository {


    override suspend fun updateProduct(
        productId: String,
        dataTitle: String,
        dataValue: dynamic
    ): UpdateProductModel {

       val abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put("query", """
            mutation updateProduct_product(${'$'}id: ID!, ${'$'}fields: ProductFields) {
              cashAssist {
                updateProduct(id: ${'$'}id, fields: ${'$'}fields) {
                  ${ApiUtils.Field.id}
                  ${ApiUtils.Field.mod_ver}
                  ...productmain
                  category {
                    ${ApiUtils.Field.id}
                    ${ApiUtils.Field.name} 
                  } 
                }
              }
            }
            
            fragment productmain on Product {
              ${ApiUtils.Field.code}
              ${ApiUtils.Field.name}
              ${ApiUtils.Field.isActive}
              ${ApiUtils.Field.altName}
              ${ApiUtils.Field.categoryId}
              ${ApiUtils.Field.nestedCategoryId}
              ${ApiUtils.Field.salesGroupId}
              ${ApiUtils.Field.unitSellCode}
              ${ApiUtils.Field.isNetto}
              ${ApiUtils.Field.isNettoForUser}
              ${ApiUtils.Field.isEmployeeArticle}
              ${ApiUtils.Field.price}
              ${ApiUtils.Field.priceInCafe}
              ${ApiUtils.Field.codeMWSt}
              ${ApiUtils.Field.codeMWSt2} 
            }
            
        """.trimIndent())



            putJsonObject("variables")
            {
                put("id", productId)
                putJsonObject("fields") {
                    when(dataValue){
                        is Boolean ->put(dataTitle, dataValue as Boolean)
                        is String ->put(dataTitle,dataValue as String)
                        is Int ->put(dataTitle,dataValue as Int)
                        is Double ->put(dataTitle,dataValue as Double)

                        is List<Boolean?> ->{
                            put(dataTitle,Json
                                .encodeToJsonElement(dataValue as List<Boolean?>))
                        }

                    }
                }
            }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString<UpdateProductModel>(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }
    }

}
